import { render, staticRenderFns } from "./BasePlaceholder.vue?vue&type=template&id=d4dc7a56&scoped=true"
import script from "./BasePlaceholder.vue?vue&type=script&lang=js"
export * from "./BasePlaceholder.vue?vue&type=script&lang=js"
import style0 from "./BasePlaceholder.vue?vue&type=style&index=0&id=d4dc7a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4dc7a56",
  null
  
)

export default component.exports